/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptions interface.
 */
export function instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptions(value) {
    return true;
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptionsFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ApiKey': json['ApiKey'] == null ? undefined : json['ApiKey'],
        'AuthDomain': json['AuthDomain'] == null ? undefined : json['AuthDomain'],
        'DatabaseUrl': json['DatabaseUrl'] == null ? undefined : json['DatabaseUrl'],
        'ProjectId': json['ProjectId'] == null ? undefined : json['ProjectId'],
        'StorageBucket': json['StorageBucket'] == null ? undefined : json['StorageBucket'],
        'MessagingSenderId': json['MessagingSenderId'] == null ? undefined : json['MessagingSenderId'],
        'AppId': json['AppId'] == null ? undefined : json['AppId'],
        'MeasurementId': json['MeasurementId'] == null ? undefined : json['MeasurementId'],
    };
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptionsToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ApiKey': value['ApiKey'],
        'AuthDomain': value['AuthDomain'],
        'DatabaseUrl': value['DatabaseUrl'],
        'ProjectId': value['ProjectId'],
        'StorageBucket': value['StorageBucket'],
        'MessagingSenderId': value['MessagingSenderId'],
        'AppId': value['AppId'],
        'MeasurementId': value['MeasurementId'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsFirebaseOptions.js.map